import React from 'react';

export default function AboutClassic({ config }) {
  const endereco = config.sobreNos?.localizacao;
  const descricao = config.sobreNos?.sobre_empreendimento;
  const primaryColor = `#${config.primaryColor || '223040'}`;
  const secondaryColor = `#${config.secondaryColor || 'fff'}`;

  // Use uma imagem fixa ou do config
  const imagemDireita = config.sobreNos?.imagem || 'https://www.mouraleite.com.br/uploads/images/2023/04/casa-em-loteamento-saiba-como-planejar-a-construcao-1680708947.jpeg';

  return (
    <section
      key="sobre"
      id="sobre"
      className="d-flex"
      style={{
        backgroundColor: '#fff',
        minHeight: '100vh',
        flexWrap: 'wrap',
      }}
    >
      {/* Texto à esquerda */}
      <div
        className="p-5 d-flex flex-column justify-content-center"
        style={{
          flex: '1 1 50%',
          backgroundColor: '#fff',
          maxWidth: '100%',
        }}
      >
        <div style={{ maxWidth: 500, margin: '0 auto' }}>
          <h1 className="fw-bold display-5 mb-4 text-uppercase" style={{ color: '#000', fontFamily: 'Axiforma, sans-serif' }}>
            SOBRE
          </h1>
          <p className="fs-4" style={{ color: "#000", fontFamily: 'Axiforma, sans-serif'}}>
            {descricao || 'Texto de descrição do empreendimento...'}
          
          </p>
        </div>
      </div>

      {/* Imagem à direita */}
      <div
        style={{
          flex: '1 1 50%',
          backgroundImage: `url(${imagemDireita})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          minHeight: '30vh',
        }}
      ></div>
    </section>
  );
}
